goog.provide('el8.uiwidget.collapsible');

goog.require('el8.template.core');

/**
* Adds a simple expand/collapse control to an element.
* The widget automates changing some status text and/or an arrow
* to indicate collapsed state.
*
* See the confidential section of the clinical profile (confidential.js)
* for a really simple usage and letterFeedRenderer.js for a more
* detailed/complicated one.
*
* @params {Object} spec Specifications such as:
*   container {HTMLObject} the HTML to be shown/hidden
*   triggerElt {HTMLObject} to trigger the collapse
*   collapseFn {function} to cause the collapse
*   expandFn {function} to cause the expansion (reverse the collaps)
*   statusTextCollapse {String} displayed upon collapse
*   statusTextExpand {String} displayed upon expansion
*   statusElt {HTMLObject} to display status of the collapse
* @returns {HTMLObject} Returns the Collapsible element
*
*/
el8.uiwidget.collapsible = function( spec ) {

    var container = spec.container;
    var triggerElt = spec.triggerElt;

    var collapseFn = spec.collapseFn || function() {};
    var expandFn = spec.expandFn || function() {};

    var consumeClick = (spec.consumeClick !== false);

    if( spec.statusElt ) {

        var super_collapseFn = collapseFn;
        collapseFn = function() {
            if (spec.statusTextCollapse) {
                spec.statusElt.text(spec.statusTextCollapse);
            } else {
                spec.statusElt.html(el8.template.core.expandIcon());
            }
            super_collapseFn();
        };

        var super_expandFn = expandFn;
        expandFn = function() {
            if (spec.statusTextExpand) {
                spec.statusElt.text(spec.statusTextExpand);
            } else {
                spec.statusElt.html(el8.template.core.collapseIcon());
            }
            super_expandFn();
        };
    }

    var doCollapse = function() {
        container.hide().attr('_collapsed', 'true');
        collapseFn();
    };
    var doExpand = function() {
        container.show().removeAttr('_collapsed');
        expandFn();
    };

    if( spec.isCollapsed ) {
        doCollapse();
    } else {
        doExpand();
    }

    triggerElt.on('el8_collapse', function(event) { doCollapse(); });
    triggerElt.on('el8_expand', function(event) { doExpand(); });

    container.on('el8_collapse', function(event) { doCollapse(); });
    container.on('el8_expand', function(event) { doExpand(); });

    triggerElt.off('click').on('click', function(event) {
        if (consumeClick) {
            event.preventDefault();
        }

        // Check if first matching element is hidden
        if (!container.attr('_collapsed')) {
            doCollapse();
        } else {
            doExpand();
        }
    });
};
